import React from 'react';
import { Container } from '@mui/material';
import BuscaAvancadaTarefas from '../components/busca/BuscaAvancadaTarefas';

const BuscaTarefasPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <BuscaAvancadaTarefas />
    </Container>
  );
};

export default BuscaTarefasPage;
